import {
    HeaderPageStyled,
    StyledTertiaryButton,
} from "features/projects/Projects.styles";
import React, { useEffect } from "react";

import GlobalConfig from "app/config/global";
import PageWrapper from "app/components/PageWrapper";
import PropTypes from "prop-types";
import RetainersDashboardNav from "features/projects/retainers-dashboard/RetainersDashboardNav";
import { useTopNavHeight } from "features/projects/useTopNavHeight";

const RetainersDashboard = ({ handleRefreshDataClick, fixedHeaderHeight }) => {
    const topNavHeight = useTopNavHeight();

    const projectsRetainersDashboardPath = GlobalConfig.routes.projectsRetainersDashboardLanding;

    useEffect(() => {
        localStorage.removeItem("storedRetainerId");
    }, []);

    return (
        <div className="selector-nav">
            <HeaderPageStyled
                top={topNavHeight}
                fixedHeaderHeight={fixedHeaderHeight}
            />
            <PageWrapper
                menuOptions={[
                    {
                        children: "Projects",
                        to: GlobalConfig.routes.projectLanding,
                    },
                    {
                        children: "Retainer Dashboard",
                    },
                ]}
                minHeight="max-content"
                displayFooter={false}
                paddingBottom="10px"
                breadcrumbMarginBottom={0}
                customAuthPath={projectsRetainersDashboardPath}
            >
                <RetainersDashboardNav
                    refreshButtonElement={
                        handleRefreshDataClick ? (
                            <StyledTertiaryButton
                                aria-label="Sync"
                                leadingIcon="sync"
                                onClick={handleRefreshDataClick}
                            />
                        ) : null
                    }
                />
            </PageWrapper>
        </div>
    );
};

RetainersDashboard.propTypes = {
    handleRefreshDataClick: PropTypes.func,
    fixedHeaderHeight: PropTypes.number
};

export default RetainersDashboard;
